// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__so8jL","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__BNdA7"};